module.exports = __webpack_public_path__ + "static/media/libro20.12de493b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/libro20.png
// module id = 368
// module chunks = 0